import { ApiResponse, IProfessionHobby, IProfessionSkill, IProfessionSubject, ITutorAgreement, ITutorEducationDetails, ITutorExperienceDetails, ITutorPersonalDetails, ITutorProfessionDetails, ITutorRequestStatus } from "@wot/typings";
import { API_URL } from "../utils/constants";
import xhr from "../utils/fetch";

export interface VerifyStatusBody {
  _id: string;
  data: {
    personal?: ITutorPersonalDetails;
    education?: ITutorEducationDetails;
    experience?: ITutorExperienceDetails;
    profession?: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>;
  };
}

export interface PUpdateTutorStatus {
  _id: string;
  data: {
    status: ITutorRequestStatus;
  };
}

export interface PUpdateTutorAgreement {
  _id: string;
  data: {
    agreement: ITutorAgreement;
  };
}

const get = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
) => {
  return await xhr({
    url: `/t/tutor-requests`,
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy,
    },
    method: "GET"
  }).then(res => res.data)
    .catch(err => { throw err })
};

const getById = async (_id: string) => {
  return await xhr({
    url: `/t//tutor-request/${_id}`,
    method: "GET"
  }).then(res => res.data)
    .catch(err => { throw err })
};

const sendIntroVideoRequest = async (email: string) => {
  return await fetch(`${API_URL}/a/request-video/${email}`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const addIntroVideo = async (body: any) => {
  return await fetch(`${API_URL}/a/add-video`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};

const updateStatus = async (
  data: PUpdateTutorStatus | VerifyStatusBody | PUpdateTutorAgreement
): Promise<ApiResponse> => {
  return await fetch(`${API_URL}/t/tutor-requests`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const updateAgreement = async (data: PUpdateTutorAgreement) => {
  return await fetch(`${API_URL}/t/tutor-agreement`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};
const tutorRequestsApi = {
  updateStatus,
  get,
  getById,
  updateAgreement,
  sendIntroVideoRequest,
  addIntroVideo,
};

export default tutorRequestsApi;
